import { faSignalStream } from '@fortawesome/pro-solid-svg-icons';
import { isPast } from 'date-fns';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyS } from '@sorare/core/src/atoms/typography';
import { Chip } from '@sorare/core/src/atoms/ui/Chip';
import { useIntlContext } from '@sorare/core/src/contexts/intl';

import { formatTimeLeft } from 'lib/earlyAccess';

const Root = styled(Horizontal)`
  padding: var(--unit) var(--double-unit);
  background: linear-gradient(
    84deg,
    #f8d3da 0%,
    #b3a9f4 28.32%,
    #fbe9fb 54.01%,
    #4f94fd 100%
  );
`;
const StyledChip = styled(Chip)`
  color: var(--c-neutral-100);
`;

type Props = {
  endDate: Date;
  desc?: ReactNode;
};

export const PromoHeader = ({ desc, endDate }: Props) => {
  const { formatMessage } = useIntlContext();

  if (isPast(endDate)) return null;

  return (
    <Root center>
      <StyledChip>
        <FontAwesomeIcon icon={faSignalStream} />
        {formatTimeLeft(endDate, formatMessage)}
      </StyledChip>
      {desc || (
        <BodyS bold uppercase color="var(--c-neutral-100)">
          <FormattedMessage
            id="EarlyAccessBlock.launched.promo"
            defaultMessage="Buy 1, win extra"
          />
        </BodyS>
      )}
    </Root>
  );
};
